import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { KitSection } from './components/KitSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Security } from './components/Security';
import { Pricing } from './components/Pricing';
import { TwoPaths } from './components/TwoPaths';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Inicialización del Pixel de Meta (Facebook)
    const f = window as any;
    if (f.fbq) return;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = !0;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      document.head.appendChild(t);
    }
    // Inicializar ambos píxeles
    f.fbq('init', '528129859587075');
    f.fbq('init', '1379391876531260');
    // Disparar eventos de carga de página
    f.fbq('track', 'PageView');
    f.fbq('track', 'ViewContent');
  }, []);
  return <div className="min-h-screen flex flex-col font-sans selection:bg-[#C5A059]/30 selection:text-stone-900" data-id="element-0">
      <TopBar data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <StorySection data-id="element-4" />
        <KitSection data-id="element-5" />
        <Testimonials data-id="element-6" />
        <FAQ data-id="element-7" />
        <Security data-id="element-8" />
        <Pricing data-id="element-9" />
        <TwoPaths data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}